import { createTheme } from "@mui/material"

const Theme = createTheme({
  palette: {
    primary: { main: '#693B9F' },
    secondary: { main: '#1976D2' }
  }
})

export default Theme